import { render } from "./BonusDetailContainer.vue?vue&type=template&id=c4035756&scoped=true"
import script from "./BonusDetailContainer.vue?vue&type=script&lang=js"
export * from "./BonusDetailContainer.vue?vue&type=script&lang=js"

import "./BonusDetailContainer.vue?vue&type=style&index=0&id=c4035756&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c4035756"

export default script